export default {
  common: {
    getDataFailed: 'Không lấy được dữ liệu',
    cancel: 'Hủy bỏ',
    noResult: 'không kết quả',
    prize: 'Giải',
    totalPrize: 'Giải thưởng tổng',
    round: 'Vòng chơi số',
    time: 'Thời gian',
    address: 'Địa chỉ',
    options: 'Đáp án',
    type: 'Loại',
    none: 'Không',
    executedSuccessfully: 'đã thực hiện',
  },
  header: {
    referral: 'Giới thiệu',
    connect: 'Kết nối',
    records: 'Lịch sử của Tôi',
    register: 'Thanh toán/đặt cược',
    disconnect: 'Ngắt kết nối',
    networkHint: 'Vui lòng kiểm tra độ trễ mạng của Bạn.',
  },
  rules: {
    top: 'Bạn đã sẵn sàng cho thử thách? Chúng tôi có 12 câu hỏi, trong đó người chiến thắng có thể nhận được hòm giải thưởng tối thiểu là $ 10.000 trong mỗi vòng chơi.',
    title: 'Quy tắc như sau',
    section1: 'Đăng ký đóng cửa lúc 12:00 PM GMT và sự kiện bắt đầu lúc 12:05 PM GMT.',
    section2: "Bạn cần đặt cược Lifeform Avatar của mình hoặc trả 1$ BUSD để đăng ký tham gia. Nếu Bạn không có Lifeform Avatar thì cần thanh toán 20BUSD để đăng ký tham gia.",
    section3: 'Tổng cộng có 12 câu hỏi. Đối với mỗi câu hỏi, bạn có 20 giây để chọn câu trả lời của mình và câu trả lời đúng sẽ được tiết lộ trong 5 giây còn lại. Nếu bạn trả lời đúng, bạn có thể chuyển sang câu hỏi tiếp theo.',
    section4: 'Khi mỗi vòng chơi kết thúc, bạn có thể hủy bỏ đặt cược.',
    section5: 'Sau mỗi vòng chơi, giải thưởng sẽ được Airdrop trực tiếp cho người thắng cuộc.',
    section6: 'Gửi link giới thiệu cho bạn bè của bạn để nhận thẻ hồi sinh. [Khi anh ấy/cô ấy sử dụng link giới thiệu của bạn và đăng ký sự kiện SuperAvatar, bạn sẽ nhận được thẻ hồi sinh]',
    section7: 'Bạn có thể sử dụng thẻ hồi sinh để tiếp tục trò chơi. Mỗi thẻ hồi sinh chỉ cung cấp một cơ hội cho mỗi vòng.',
    section8: 'Các thẻ hồi sinh không được sử dụng sẽ tự động hết hạn sau mỗi vòng.',
  },
  home: {
    prizePool: 'Hòm giải thưởng',
    totalParticipants: 'Số người tham gia',
    round: 'Vòng chơi số ',
    startIn: 'bắt đầu vào',
    connect: 'Kết nối',
    register: 'Đăng ký',
    registered: 'Đã đăng ký',
    enter: 'Đăng nhập',
    ongoing: 'Đang thực hiện.',
    ended: 'Đã kết thúc',
    cumulativeRanking: 'Bảng xếp hạng lũy kế.',
  },
  register: {
    registerRecords: 'Lịch sử đăng ký',
    registerForRound: 'Vòng chơi đăng ký số',
    youCanChoose: 'Bạn có thể chọn',
    pay: 'Thanh toán',
    or: 'hoặc',
    stake: 'Đặt cược',
    staked: 'Đã đặt cược',
    paid: 'Đã thanh toán',
    inviteFriends: 'Mời bạn bè chơi.',
    insufficientFunds: 'Số dư không đủ',
    registerSuccess: 'Đăng ký thành công',
    registerFail: 'Đăng ký thất bại',
    onceRegistered: 'Sau khi hoàn tất việc đăng ký, bạn sẽ nhận được kỷ niệm chương SuperAvatar của vòng này.',
    checkMyMedal: 'Tra cứu kỷ niệm chương của tôi.',
    backToHome: 'Quay lại trang đầu',
  },
  records: {
    myTotalPrize: 'Tổng số tiền thưởng của Tôi',
    myRecordsInSuperAvatar: 'Lịch sử của Tôi trong super avatar',
    round: 'Vòng chơi số',
    totalRegistered: 'Số người tham gia',
    totalPrize: 'Giải thưởng tổng',
    winners: 'Người chiến thắng',
    defeat: 'Đánh bại',
    myPrize: 'Tiền thưởng của Tôi',
    myRecordsOfPayStake: 'Lịch sử thanh toán/đặt cược của Tôi',
  },
  share: {
    share: 'Chia sẻ',
    referralUrlCopied: 'Đã sao chép link giới thiệu',
    showItOff: 'Vinh danh',
    invitingYouTo: 'đang mời Bạn chơi.',
    theWinnersTakeAll: 'Người thắng chia đủ',
    yourReferralUrl: 'Link giới thiệu của Bạn',
    downloadAndShare: 'Tải hình ảnh và chia sẻ',
    comeToWin: 'Đi đến super avatar để nhận tiền thưởng.!',
    iHaveDefeated: 'Tôi đã đánh bại',
    ofThePlayers1: 'người',
    ofThePlayers2: 'chơi.',
    isTheWinnerOfThisRound: ' là người chiến thắng của vòng chơi này. ',
    hasWon: 'Đã thắng được',
    comeToTogether: 'Hãy cùng nhau giành được nhiều tiền thưởng hơn nữa',
    hereRecordOf: 'Kỷ lục của trò chơi này',
    knowMore: 'Tìm hiểu thêm về super avatar',
    iHaveWon: 'Tôi đã thắng',
    everyDay: 'mỗi ngày',
    resurrectionCardUsed: 'Đã sử dụng thẻ hồi sinh',
    everyDay12GMTAAnswer: 'Mỗi ngày vào lúc 12 giờ trưa (GMT), hãy trả lời đúng 12 câu hỏi và ngay lập tức chia đều 10000 BUSD. Tham gia liên kết:',
    totalHighAs: 'Giải thưởng tổng',
    everyDay12GMT: 'Mỗi ngày lúc 12 giờ trưa (GMT)',
    answer12Today1: 'Trả lời đúng 12 câu hỏi, người chiến thắng ',
    answer12Today2: 'sẽ chia đều tất cả giải thưởng trong ngày',
    numIHaveDefeated: 'Tôi đã đánh bại ',
    numOfThePlayers1: 'người chơi',
    numOfThePlayers2: 'và gần như đã có',
    holdDownShare: 'Nhấn giữ ảnh để chia sẻ',
    win: 'thắng lợi',
  },
  stake: {
    registerByStaking: 'Đăng ký sử dụng đặt cược',
    unstakeAllAvatar: 'unstake all avatar',
    chooseYourAvatar: 'Chọn avatar của Bạn',
    stake: 'Đặt cược',
    unstake: 'Hủy đặt cược',
    unstaked: 'Đã hủy cọc',
    approveToken: 'Vui lòng cung cấp loại token dùng để đăng ký.',
    approveNFT: 'Vui lòng cung cấp NFT dùng trong tiền cọc.',
  },
  match: {
    watching: 'Đang theo dõi',
    sorryYouAreOut: 'Rất tiếc, bạn đã thua cuộc!',
    wishNext: 'Hy vọng bạn sẽ giành chiến thắng trong các trò chơi tiếp theo!',
    totalPrize: 'Giải thưởng tổng',
    survivedAndTotal: 'Sống sót/Số người tham gia',
    prizeForEach: 'Tiền thưởng mỗi người có thể đạt được',
    rememberTo: 'remember to',
    unstakeYourAvatar: 'unstake your avatar',
    congrats: 'Xin chúc mừng.!',
    areWinner: 'Bạn đã là người chiến thắng của vòng chơi này.',
    almostWinner: 'Bạn suýt trở thành người thắng cuộc!',
    keepLearning: 'Cố gắng hơn nữa để trở thành người chiến thắng trong các vòng chơi tiếp theo!',
    toGetCard: 'Đạt được thẻ hồi sinh của vòng chơi sau',
  },
  referral: {
    currentRound1: 'Hiện đang ở vòng chơi số',
    currentRound2: '',
    inviteYourFriendsTo: 'Mời bạn bè tham gia để được tặng thẻ hồi sinh của vòng này',
    referralRecords: 'Lịch sử giới thiệu',
    round: 'Vòng chơi số',
    resurrectionCard: 'thẻ hồi sinh',
    usedOrNot: 'Có đồng ý sử dụng hay không',
    invitedUsers: 'Người chơi được mời.',
    used: 'Đã sử dụng',
    unused: 'Chưa sử dụng',
    none: 'Không',
    viewDetails: 'view details',
  },
};